// export const headApi = `https://api.bangles.org.in/api/rest`;
// export const localApi = `http://localhost:8085/api`;
// export const localApi = `https://inshabangles.com:8443/api`;
// export const localApi = `https://bangles.org.in:8443/api`;
// export const localApi = `https://api.inshabangles.com/api`;
// export const localApi = `http://localhost:8089/api`;
// export const localApi = `https://api.inshabangles.com/inshaApp`;
export const localApi = `https://api.inshabangles.com/inshab2b`;
export const localApiImage = `https://inshabangles.com/imgstore`;

export const adminId = "2";

export const username = "admin";
export const password = "Insha_!@#$21Bangles";

export const credentials = btoa(`${username}:${password}`);

export const roundUp = (num, decimals) => {
  const factor = Math.pow(10, decimals);
  return Math.ceil(num * factor) / factor;
};

export function convertToNextTenth(num) {
  return (Math.ceil(num * 10) / 10).toFixed(2);
}
